// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".opinionCon .el-textarea{height:100%!important;width:100%!important;margin-top:1px}.opinionCon .el-textarea .el-textarea__inner{height:100%!important;width:100%!important;border:0;padding:1.302vw 1.51vw}", ""]);
// Exports
module.exports = exports;
